

import type {
  GetCertificatesPayload,
  CreateCertificatePayload,
  GetCertificateByIdPayload,
  TransferCertificatePayload,
  CancelTransferCertificatePayload,
  GetCertificateProvenancePayload,
  GetCertificateScansPayload,
  EditCertificatePayload,
} from './types'
import type { ActionCallback, IValidationCallback } from '../model'

import { CertificatesActions } from './types'


export const getCertificates = (payload?: GetCertificatesPayload, callback?: () => void): ActionCallback => ({
  type: CertificatesActions.GET_CERTIFICATES,
  payload,
  callback,
})

export const getCertificateById = (
  payload?: GetCertificateByIdPayload,
  callback?: IValidationCallback
): ActionCallback => ({
  type: CertificatesActions.GET_CERTIFICATE,
  payload,
  callback,
})

export const createCertificate = (
  payload: CreateCertificatePayload,
  callback?: IValidationCallback
): ActionCallback<CreateCertificatePayload> => ({
  type: CertificatesActions.CREATE_CERTIFICATE,
  payload,
  callback,
})

export const transferCertificate = (
  payload: TransferCertificatePayload,
  callback?: IValidationCallback
): ActionCallback<TransferCertificatePayload> => ({
  type: CertificatesActions.TRANSFER_CERTIFICATE,
  payload,
  callback,
})

export const editCertificate = (
  payload: EditCertificatePayload,
  callback?: IValidationCallback
): ActionCallback<EditCertificatePayload> => ({
  type: CertificatesActions.EDIT_CERTIFICATE,
  payload,
  callback,
})

export const cancelTransferCertificate = (
  payload: CancelTransferCertificatePayload,
  callback?: IValidationCallback
): ActionCallback<CancelTransferCertificatePayload> => ({
  type: CertificatesActions.CANCEL_TRANSFER_CERTIFICATE,
  payload,
  callback,
})

export const getCertificateProvenance = (
  payload?: GetCertificateProvenancePayload,
  callback?: IValidationCallback
): ActionCallback => ({
  type: CertificatesActions.GET_CERTIFICATE_PROVENANCE,
  payload,
  callback,
})

export const getCertificateScans = (
  payload?: GetCertificateScansPayload,
  callback?: IValidationCallback
): ActionCallback => ({
  type: CertificatesActions.GET_CERTIFICATE_SCANS,
  payload,
  callback,
})
